<template>
    <div
        class="setting-selected-country-item"
        @mousedown.stop=""
        @mouseup.stop=""
        @click="updateOpenStatus"
    >
        <span v-if="countryData">{{ countryData }}</span>
        <span v-else>{{ $t('app.userSetting._') }}</span>
        <span
            class="arrow-icon"
            :class="[ isOpen ? 'ai-open': 'ai-close' ]"
        />
    </div>
</template>

<script>
export default {
    model: {
        prop: 'countryData',
    },
    props: {
        countryData: {
            type: String,
            default: '',
        },
        index: {
            type: Number,
            default: -1,
        },
        currentKey: {
            type: Number,
            default: -1,
        },
    },
    computed: {
        isOpen() {
            return this.index === this.currentKey;
        },
    },
    methods: {
        updateOpenStatus() {
            this.$emit('updateCountryListStatus', {
                currentKey: this.isOpen ? -1 : this.index,
                countryData: this.countryData,
            });
        },
    },
};
</script>
